/** Matches BlogPost#tags_format (single char or alphanumeric with internal spaces/hyphens). */
const BLOG_TAG_PATTERN = /^[a-z0-9]([a-z0-9 -]*[a-z0-9])?$/

/** Normalize and validate a tag from user input; returns null if invalid. */
export function normalizeBlogTagInput(raw) {
  const tag = raw
    .trim()
    .toLowerCase()
    .replace(/^[-\s]+/, "")
    .replace(/[-\s]+$/, "")

  if (!tag || !BLOG_TAG_PATTERN.test(tag)) return null
  return tag
}

/** Collect unique tags from posts, sorted alphabetically. */
export function collectBlogTags(posts) {
  const tagSet = new Set()
  posts.forEach((post) => {
    post.tags?.forEach((tag) => {
      if (tag) tagSet.add(tag)
    })
  })
  return [...tagSet].sort((a, b) => a.localeCompare(b))
}

/** Read ?tag= from the current URL (public blog index). */
export function readBlogTagFromUrl() {
  if (typeof window === "undefined") return null
  const tag = new URLSearchParams(window.location.search).get("tag")
  return tag?.trim() || null
}

/** Update ?tag= without a full page reload. */
export function writeBlogTagToUrl(tag) {
  if (typeof window === "undefined") return
  const url = new URL(window.location.href)
  if (tag) {
    url.searchParams.set("tag", tag)
  } else {
    url.searchParams.delete("tag")
  }
  window.history.replaceState({}, "", url)
}

/** Filter posts that include the given tag (case-sensitive; tags are normalized on save). */
export function filterPostsByTag(posts, tag) {
  if (!tag) return posts
  return posts.filter((post) => post.tags?.includes(tag))
}

/** Human-friendly label for URL-safe tags (e.g. morning-routine → Morning routine). */
export function formatTagLabel(tag) {
  if (!tag) return ""
  return tag
    .split(/[-_]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
